import React, { useRef, useCallback, useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Loading } from '../../components/Loading';
import { useAuth } from '../../hooks/auth';
import { MD5 } from '../../hooks/md5';
import { maskCpf, isCpf } from '../../components/Input/mask';
import Button from '../../components/Button';
import RadioButton from '../../components/RadioButton';
import api from '../../services/api';
import ModalConexao from '../../components/ModalConexao';
import DrawerApp from '../../components/Drawer';
import {
  Container,
  Content,
  ContentSubHeader,
  ContentSubBody,
  ContentTitle,
  ContentText,
  ContentButton,
  ContentSubLabel,
  Line,
} from './styles';

interface SignInFormDataCPF {
  cpf: string;
}

interface SignInFormData {
  r1: number;
  r2: number;
  r3: number;
  r4: number;
  r5: number;
  r6: number;
  r7: number;
  r8: number;
  r9: number;
  r10: number;
  r11: string;
  r11Justifique: string;
  r12: number;
  r13: number;
  r14: number;
  r15: string;
  r15DataInicial: string;
  r15DataFinal: string;
  r16: string;
  r16DataInicial: string;
  r16DataFinal: string;
}

interface Person {
  id: string;
  nome: string;
  cpf: string;
  dataNascimento: string;
}

interface PersonGet {
  RA_FILIAL: string;
  RA_NOMECMP: string;
  RA_CIC: string;
  IDADE: number;
  ABS_DESCRI: string;
  ID: number;
  NOME: string;
  EMAIL: string;
  CPF: string;
  DATA_NASCIMENTO: string;
  DOENCA_PULMONAR: string;
  DOENCA_CARDIOVASCULERES: number;
  DIABETE_INSULINO_DEPENDENTE: number;
  HIPERTENSAO: number;
  DOENCA_RENAL_CRONICA: number;
  DOENCA_ONCOLOGICA: number;
  SISTEMA_IMUNOLOGICO_ENFRAQUECIDO: number;
  OBESIDADE_MORBIDA: number;
  DOENCA_NEOPLASIAS_MALIGNAS: number;
  ASMA_GRAVE: number;
  OUTRAS_ENFERMIDADES: number;
  JUSTIFICAR_OUTRAS_ENFERMIDADES: string;
  USO_MEDICAMENTOS_IMUNOSSUPRESSORES: number;
  GESTANTE: number;
  EH_LACTANTE: number;
  TESTOU_POSITIVO_COVID19: number;
  DATA_INICIAL_TESTOU_POSITIVO_COVID19: string;
  DATA_FINAL_TESTOU_POSITIVO_COVID19: string;
  TEVE_RESIDENTE_POSITIVO_COVID19: number;
  DATA_INICIAL_TEVE_RESIDENTE_POSITIVO_COVID19: string;
  DATA_FINAL_TEVE_RESIDENTE_POSITIVO_COVID19: string;
  DECLAROU: number;
}

const AutoDeclaracaoDeSaude: React.FC = () => {
  const { user, userAcesso } = useAuth();

  const formRefItens = useRef<FormHandles>(null);
  const formRefAceite = useRef<FormHandles>(null);

  const history = useHistory();

  const [cpf, setCpf] = useState(user.cpf);
  const [aceita, setAceita] = useState('');
  const [verificaAceita, setVerificaAceita] = useState('');
  const [dataPerson, setDataPerson] = useState<Person[]>([]);

  const [loading, setLoading] = useState(false);

  const [r1, setR1] = useState(3);
  const [r2, setR2] = useState(3);
  const [r3, setR3] = useState(3);
  const [r4, setR4] = useState(3);
  const [r5, setR5] = useState(3);
  const [r6, setR6] = useState(3);
  const [r7, setR7] = useState(3);
  const [r8, setR8] = useState(3);
  const [r9, setR9] = useState(3);
  const [r10, setR10] = useState(3);
  const [r11, setR11] = useState('3');
  const [r11Justifique, setR11Justifique] = useState('3');
  const [r12, setR12] = useState(3);
  const [r13, setR13] = useState(3);
  const [r14, setR14] = useState(3);
  const [r15, setR15] = useState('3');
  const [r15DataInicial, setR15DataInicial] = useState('3');
  const [r15DataFinal, setR15DataFinal] = useState('3');
  const [r16, setR16] = useState('3');
  const [r16DataInicial, setR16DataInicial] = useState('3');
  const [r16DataFinal, setR16DataFinal] = useState('3');

  const [crypto, setCrypto] = useState('');

  const handleDownloadPDFnaoDeclarante = useCallback(() => {
    const today = new Date().toLocaleDateString('pt-br');
    const nomePDFdeclarante = `Eu, ${dataPerson[0].nome},`;
    const cpfPDFdeclarante = `portador do CPF: ${maskCpf(
      dataPerson[0].cpf,
    )}, declaro para todos os fins, que:`;

    if (dataPerson) {
      const doc = new jsPDF(); // eslint-disable-line
      // doc.setDrawColor(0);
      // doc.setFillColor(40, 38, 46);
      // doc.rect(0, 0, 210, 70, 'F');
      doc.addImage(
        'data:image/png;base64,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',
        'JPEG',
        40,
        10,
        0,
        0,
      );
      doc.setFontSize(20);
      doc.setTextColor(0, 0, 0);
      doc.text('Comprovante de Preenchimento Virtual', 40, 55);
      doc.text('de Autodeclaração de Saúde', 56, 64);
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(nomePDFdeclarante, 10, 93);
      doc.text(cpfPDFdeclarante, 10, 99);

      doc.text(
        '- Não desejo declarar informações sobre minha condição de saúde!',
        15,
        110,
      );

      doc.text(`Formulário preenchido em: ${today}.`, 115, 240);

      doc.setFontStyle('normal');
      doc.text(`AUTENTICAÇÃO:`, 15, 280);
      doc.setFontStyle('bold');
      doc.setFillColor(0, 38, 153);
      doc.text(`${crypto}`, 53, 280);
      doc.save(`declaracao-${dataPerson[0].nome.trim()}.pdf`);
    }
  }, [dataPerson, crypto]);

  const handleDownloadPDFDeclarante = useCallback(() => {
    const today = new Date().toLocaleDateString('pt-br');

    const nomePDFdeclarante = `Eu, ${dataPerson[0].nome},`;
    const cpfPDFdeclarante = `portador do CPF: ${maskCpf(
      dataPerson[0].cpf,
    )}, declaro para todos os fins, que:`;
    const r15DataInicialTradado = `${r15DataInicial.substr(
      8,
      2,
    )}/${r15DataInicial.substr(5, 2)}/${r15DataInicial.substr(0, 4)}`;
    const r15DataFinalTradado = `${r15DataFinal.substr(
      8,
      2,
    )}/${r15DataFinal.substr(5, 2)}/${r15DataFinal.substr(0, 4)}`;
    const r16DataInicialTradado = `${r16DataInicial.substr(
      8,
      2,
    )}/${r16DataInicial.substr(5, 2)}/${r16DataInicial.substr(0, 4)}`;
    const r16DataFinalTradado = `${r16DataFinal.substr(
      8,
      2,
    )}/${r16DataFinal.substr(5, 2)}/${r16DataFinal.substr(0, 4)}`;

    if (dataPerson) {
      const doc = new jsPDF(); // eslint-disable-line
      // doc.setDrawColor(0);
      // doc.setFillColor(40, 38, 46);
      // doc.rect(0, 0, 210, 70, 'F');
      doc.addImage(
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAdgAAAB5CAYAAACa7jBmAAAgAElEQVR4Xu19e5ybRbn/d953s9lN71cKVmoROSr+5OJRQaiocGqbZEsvtEVBpHAuXriJNtmitUC13WwBoZzj3aLVcqBAW+gmlB7r4SqICsJPLgKWcivYAr1sN9tNNu+czySbNrub5J1n3jdvsrvz/kXZZ5555juT9/vOzHNhGIzPiuBxyCQvQveE7+KaO1Jb2rZM29ex74yFCxd+bzAOV49JI6AR0AhoBGoPAVZ7Jjm06IITjsMpx/0Ze9tTuGrLOKFNEGyapx9MpVK/nDdv3iKHPejmGgGNgEZAI6ARsEVgcBFsa9MZSKfjaPANQzqzFc2JzwsEHt7yu+P3pDv+Kv6bZdi2ZCoZXLBgQcoWHS2gEdAIaAQ0AhoBRQQGD8Eu/9SiI4cdueZNngK6LSDTvQ1X3XdWX4Ltwel5wzBmhEKhVxRx0800AhoBjYBGQCNQFoHBQbAtoe8zxq7i4LnBMgZ0p8sRrJDa72O+8IzwjIf0GtEIaAQ0AhoBjYDbCAx8gm0NrwPDF5kFEAkWo0aNwmOPPXZuJBK53W1gtT6NgEZAI6ARGNoIDFyCva5p/IS6hs1vd3WecohY83Mpt4M9NPOGYXwvFAotHdpLQY9eI6AR0AhoBNxEYGAS7KoZH0XGiNeb5uSUZfXHQ5JgLcuCYRjw+Xzo6OjQHsZuriytSyOgEdAIDHEEBhzBmhecOqf+5EkbOjPdQNoCio1AkmDzc58nWr/f/8gbb7wRXrRo0d4hvi708DUCGgGNgEbAIQIDimCNWPgSy8DNsHqcmUoNnkiwhWq6urpeSyaTwQsuuCAb1qMfjYBGQCOgEdAIqCAwcAh22aduPHLUkZe/melCpQg2v5M1DCPd2dk5+5xzzkmogKrbaAQ0AhoBjYBGoPYJdv18c8xr3RvqMtas3VZ38SPhvvPoYAdbqGrc6NEXf2ratDV6mWgENAIaAY2ARoCKQG0T7A3h9+BAVxyN/hNsd62FI3eJYBsbG/HMM8+0XH755UuowGp5jYBGQCOgERjaCNQuwS465ZM48YgEUpmxyHC5nWt+Ll0iWHFk7Pf7hafxxunTp88d2ktFj14joBHQCGgEKAjUJMG+t3X2F15j3beSdq0V2MHmVZqmia6urkfT6fTcBQsWvEUBWMtqBDQCGgGNwNBEoPYI9pppSyc0jr12N8vYOzOVmjOXdrB59XnnJ9M0/9HZ2dk0b968Pw7N5aJHrRHQCGgENAKyCNQUwU65fs4vkhnrot28W9b+4nIuE2xhJ4JsOefnzp49W6dXdDZLurVGQCOgERjUCNQGwS77zHCWMTf7RgU+UzQzE3UKKkSw+Z2scH56/vnnL7/kkktWU03T8hoBjYBGQCMwNBCoPsGuCB4Hk8VHmL5j27vTNGcmj46I+3ZT4Px0y/Tp0y8aGktFj1IjoBHQCGgEKAhUl2Bj4TMBfg8YC4DbZGcijUqqXB1FY0nZzs7OLQDO1gXcXYFTK9EIaAQ0AoMGgeoR7OJpF2LCqFuySLpJrkJfhY6Ii+1kRbEAALqA+6D5SeiBaAQ0AhoBdxCoCsEasdC1lt9ciq6MO6Poq8Ujgu3TrS7gvmx+PYYdPBUW/xgMfhw4JgN8dA4ndhCcvwGw18HYk+B4HM1tr1ZmAWitGgGNgEZAAgGRzKgbxwN8Mjg7ArDqASMFzvcCfCdgvoTmzc9IaCoq4j3BLj/rdjQ0LFCOcZUZaXUINmtZd3f3ojlz5vxSxsxBI9PadAZgfQEcTQCOkhxXBuCPgRsbUMfW4lub35ZsJye2qmkqLKs1J8wr9CUnYwozwfE7NMd/VFJ6/XwT25PXgmE0ONyxlSFjAO0A22Ux7IbF/or6hu248o5OGaulZWLBZWDsSFhI2bYxUA/w1xFJfM9WliIQC30ZDKdK2cBgZlWbxjKZNZctMAJ+hvwaYjn9PnYFrmx7gzKMXrKx4GKAfUKuX9Enux3RtjuV+5NpKGxi7P1SOPfVl8M9BV/gKtfXoIzthTKxmaeAsTng7CwAHwHEuiz77ACwDYxvQiTRRunOO4K9rmk8MlZ8Aqv7hOMwHLsRVpFghWlDpoB768zTYLHvgrHpdlNi8/cDAH4OI70Si7fucqgr11z8iGA86oou50q2IRoXP+bizw3zG5FOJp13Y6vhLTD8ARaLox4JRwSQ7yoWehHAsbY9FwrwrtFo/u0+UptywrGQIDLZD7ucpmTHCFxzv1h35Z9Y6AEAn7YT6/d3xq5ApO0mcrvDuP4ZwMmE9j9ENP51gjxNdNlnhiMwrJ3WqJi0dSqi9z7mXI+ChljwX8DxLYfvq5cMsJusaNt/yljgDcGKAumWeR8Ym+T6fWuxUVaZYEUB9507d9560UUXnSczCQNSJha8HmBXumo7x36DsW/LLt6yfbcGTwRnT7pqn6oyzteiOfHlks3F0Xog+QqASapdKLRLgeEWdPMbcFXiBYX2uSatwRg4i5DaW/hnLIkLAnH+iI+TVFJ8OIwkKCv/wVOoqDW8Dpx/kaA7J8r5VjQnPk9ul28QC24E2Gz59vxqRBPXyMsTJVeGPgYDfyK26i/OcDEicW8LqIjNncVvUprHkgPmT4OZlyGyWXyAlXwqT7DLp80e0ThuY7uohOO2M1OpYVWZYEUYz7Bhw2BZ1uAr4N5y1iiw+jjATnP8YyutII5kx7lSO4xSOjTByk5PBmBLEW1bKdugl5w4ngWIVyLsfETb1in117dRS9PxYBa1dvONiMa/IdW/KsGK49BkxzjlNVxrBKs0z0URlsdeaoJshLKRKrgV4BPdUFfki+Gqcr+dyhJsa/hyADd6Rqz50QuC5dYjiCZOF//r4S2/O35PuoP6I3RlPkQB90nDx848fcbnlC/KXTHEDSUrQ2Ng4HHykaBa3ztgGJ/D4s0vKzXXBEuFbQumBsJYcAftDlhhZ2MAy61o/LtUA4vKx5pmA9ZGki7O/h3NbT+TaqNOsIDB5mJxG822vFG1RrAqJxXFAZY/PZCaoDJC7n0U2FnyC0Tj/1pMqHIE23zGTRgz/LJsyIxXO9caI9h85idxZHzgwIHQgC/g3hp6DhwftFttLv79bfjYiUp3hZpgVabhCUTjHyM1zN3N/QNAQL4dvx3RxLny8uVeouElAF9B00W4B3RCsEDJF6+tvbVGsLGQcO4J2dptL/AWovEj7cUcSnhHrjlDS1wDuU+wwiNyR8dG1Nc1ISUcRR0CRWluWUB9HZCxtoNl5mDxlqfzze++++5LDMO4Wfw7T3wU1W7IWpZ16dlnny11Oe5Gf67qiIXuAHCOqzrllO1AMvBPuOYOey/VQn2aYOXQ7S+1BdH4TFLjWIjqkEMn8lIGtQR/BcYuINibAu+aKO1k5Yxg1cmk9ghWnCS9j4BzaVHDOEb5ZErGAOHMBLZVRtRVGcZbEUlEC3W6S7D5AukN/hM837WKUTXWge06cD83M03F7j7uvPPOoGmabXV1de6OmzBL6XR69dy5c8XR+cB5WsMLwfltVTOY8c2IJGaR+tcES4KrlzDVA7Y19GtwnE/o8AB8gYmuhGvEgg/T/AH404gmTpC21RnBis95Na/ZWiJY8V5P89elMbMT5Hw2mhN324kp/X3V9ImwfDtFIJZSe8eNjDmIbt6UV+Me0cRmnmIavnsDzBjdnkk7NlNJQcD8FS6958JybdeuXfuR8ePH/zaTyRxRrZ2s3+8fOAXcxYnEy8m9AIYrzYlrjdh8UpyfJlhnyJvGBJk40WwnMYVjWiNzQuEJk5KxubUp6jOPl27P2K2ItMl79zskWOX75loi2NbwdHB+nzTGtoKsrGOQbfNyAuQPLke9FWvc64TEHYK9+rNfxIjh69BtuW6tncJ6w4CfmWjPpKTd1G+55ZbRo0ePTvj9/lMzGZpPh509sn9vb2//S11d3cyaL+CeC3jvSdggO7oKyHHsxzGBsdJOOJpgnU6CfFxlazAMzjbTOiR+MBVTnisU8jdiv7SXu0OCBYg75vxgaolgW8JXgvHraTiXk3bxDr6wm2qftB3etv4GkfiXxD8dE2wgOv07ydHmcpim985MhkjqnwG6Dp6Hq//3VuoC2Lp16xqReSmdTovkENTmyvL5ajyWZdV+AfdY+B8OXNy3GcDvLc5eAxO7DC4C58VRr13mlKLYGmCXSsfIaoJVXp89DTNIdoyWCjPJZc3aTuqQ8aWOMzqtDM6Awe4l9ttEysbjmGCFAwybQk4LWksEGwv9HMDFJJzLCit+dNgZEAu96XEseWmLeu6ZnRGsAN5vXoy0BWS4C3Rth2DP34XjlM9AwKh7N/nuu7Ox/IGHJFv2E7vppptWnnTSSc379rmXWIZqSyaTqc0C7qrOAmK3yflCLEmISkO9H3Gfk7JWEB1T8jp2IBqfKoVvLRGsSLNWLpNTdRJNyMB4IaLxX8kIgppNyS75hkynKjsrqoONKwSLr5VNlVlsrLVFsH8A8AmZKZGUoTmayShdFZ4Di2+QES0h8wQ4/yvA9sHA0eD4ODk7WKFihp8gEv+KGsEK13y/fxPq6s701EtYDIAxNNb70Ln/wFOBHW8Hk2ueFBfajp7fP/TQRbvfffcXXu5iCw02TRN79uxpPu+882KOBuJ249bQj8HxH0S14vPneETjz5VtJ3LYgl1N1A1YmU9gyZY/2rajE2wGnK+DwdzN1WvxRjD2u7JEpUawrwJ8LxjrfRpg8dw9jSgBmbubdHB3zjchmphji7UQiIV+C0AE9cs+jyMa/6SscFE5+vqke/W6QbBAHNF4mDTWWiFYsTYbk7uJmbIkhqro/FVKcywkTjJmSHTcR4RvgmWt6PdOyRYuSZ4PjusAjCHrFZuMzsAEOsH2FEifwOqOrXhO4WKjYgyM8TifEjhb+j5OAp0tbVumpXlaxHpRUq5JaJYTESTb2dn5y3nz5i2Sa+GBVEvwGTD2YVJPFA/U1tAmcJxN0s+xAs3xb9u2oRNsCtG431ZvJQRUCJYZn7FL04ZsirjMKTkPX7aQbjrbhamNR0n9zmKhHwC4gtDHHiQDk8jhV4UdUEldJX2hOwR7EL7AWJLXdK0QrFqmLPtlQEn2YactF4v9DvnqSeZd0hqcBLD/VYv/59NpBHuoQDoCnu9cBciNdcDOvavR8kBFwlzi8fgUy7LEsaaXyRR6LZ+aKeCec3cXHpqENcJ2Idp2hN3v4dDfc5mhdhNd6uUywagQrJF+r2vFBqRBAKBEsNbpiNz7iHQ3sfA5ABexzNTnw7anEUJjS/jfwPhPScoz/J8c5UGmHkuLrHKyKRLzA3GHYIV/Ci00pVYItlKOQxw3ozl+GWm9lBJWuosneJPnCtWIOGDaaRDHCvmXp/gBGcj9gLzOzCT6FJZa7JtobrvBlUkpoWT9+vX1gfpAgpucctzlmkki61M6nX7+ueeeC0cikb+7ppiqSJSg49b9xGb0Fxg1gQXnr6M58V5bu1QIlvEpiCTER4W3jwrBgp2FaNs2kqEqHuGyxCAqK3HjYZI9jNMcjgqVt4SPBuOiQIL8o5Jo3i2C7bmTkza2Rgg2W7sbWCptt7yg3IeyjD56mNgBJAPjSKcnLaGvguGHMuYUyMSlCHbYN/8l1jG5MZLNzOTxw4T7KTOx20rTvgAd2rlhw4abRo4ceVkqlRKE56mXcY/p1S3gHgufB/DfkGBUyb3aGroIHL8g9JOBkT7KdqepCbY4pERPS2nP7dxphPg4kfcQ5w4+mHOnaeLeV/6Rvb8v1OgWwQI7EY2/R9rYGiFYUD+ApQeItzA1MFnq+sFOJ/UunvqxI/rP1Wx+l3YXzZ+2JdhR187473315rkQITFe7lwZMMLwoT3TvQsWD7pW3spusgr+vnHjRlGGq6UamZ/EnayI0a1aAXdRqIHzGwlwASrJA1RelDJHi5pgi08d9WUEQhk06p29yosuPyr6juIgkh0TpMKOKkOwAKVMX60QbCXzj8v8jmVeQOSPAMVqTvQ7/9dLE2zu3Pk+1JsnZ8NwvCRXAWquSMDjMNJNtrsVmUlQlGltbV14yimn3FbNMJ6qFHBvDX4HnC0nwMbhY+8lJ+ZXOYrmxkfQvLl8dSJNsCUIlvjhxHAdIvHFUuuA/KLDg4jGz5DS3VeoJbQaDJfKt1WMvXRvByvu1qST4aAWCDbHAeJUQjbt4EsAxkl73cpeP9hNMrUQgerVRCx4G9FZ8O3iBJt7OcXB2FGeE6sAs96E8XbH7db3t7lTccNugmz+ftddd32cMbbF5/ONdahKuTnn/I5Zs2YtUFZAbKhw95IB45PJd5gqO1hNsOILlH4HK9YAvcqI/L06PfRqJ6YGjlY6JmwJ3gfGpksva2qKxLxiVwkW8kUOaoFgqR+/jLWA889Jx8y6kWwkt6ZplX5UiZ3+AVmEYFuCZ4Oxu8CYWRVyzVI+a0GkbYn0j8cDwfXr109qbGhMgOEkD7rr14U4Mu7q6np07969wUWLFoncwJV96C9LgBrEn/1xKNylaYKtUYJV8FRWyXKUe6m+SKtLrJj/1l2CBXxsstQpTy0QLPkYnp0F8K/IV91yKWXigCHY1vDljONGXpUYnB6+UPH0qyzV9NJ+zz33rK+vr58v0h1Wyfnp9TG+YTMqXsBdJUuOTGxm37nSBKsWplOTO9jQhwA8S/s58umIJv6H1EalYorqsaDbBCsb/1kLBBsL/ReAr0nPTTLgR2PyOvmje8Vj+37vkIGwgxV3Gga7tBq7VpGwP+VjSXRZs8ihB9Kz757gw/HftR4wU4sFwXpdkUfsZDnn6c7OztkVLeCu4kWs4hWqCXbwEKxCdRtpL+XCn69KSJDK6Yro022CZbgbkfhs27dRbRDsAwA+bWtrTmAPovGxxMpK7qRMrOkd7LL59ezgO5v4pOEzqxGGA78Jls7E+WJiKjHJWa+U2OrVq6d97pOnr0t2HrSPyayQEZNGTfj60Sd9gBqbJWeNykvMLudusZ41wQ4egs0e3RLrs6okHKCHdtFCZHqReXgdOP+i3I9GSioJX2C8bVanahNs9mOpcyeh0Ecu9SX1w5wRE6YUfYfU8g42FvozDHYyLJFC1sNH3LU21AHvHuR4Y08r9rLt8JtH9VjgtjG24UgSIxc2MbTvyuV6HTnx5S8c87GLRzUG1LwgJTq0ExnpD+CpN7evv++tvyzF2qdesJMn/V0tyxJgpI8geX1rgh1cBEsNA1JKXxiMgTMRQif3qPSR1+z2DlbotfjMooUwCkdTbYKllgLMO5HFZp4CGI/KTUy20tC/o7ntZ9LyA41gWSzMuajU5hXBCpoyGcTOFW92AH8/ADMDZAJGLluT29TqaOZKNBZ2ijJ5+3YhW6avWo+oZdvYCDSOvgC//v2vXTdDfHwBosSc/CM8CSkOaiq1RBk/CZHEX8oapcN0isNTSS9iAEYsfIkFfrP8goF8haRDpEfNYc1vQDTxTYJNh0UrQbCAfa3dahNsztl1kzRmeY9g6v24yglGX6Nq+oi4JSTK84z0hNh6ysxlCfbVduCVDsDPgDpRS1Z6KrVgHwRMxudm1j660XVgYsHrAXYlUW8KvsBo2yOwvNJs+To+C2Dd0v1wfieWxPdogiWmShSAVZhgFbzC6eFd9OQH8mX3+i6qyhDsq4jGp5Rdv9UmWHIcPJuPaNud2THRPLydp0z0jmBp4UBAksErghUEKnat4nlpP/BWUpOrNKOUF6wYwardw4oEIWvRnPiyS8NTU6N3sFXZwYK6gxFWUrzPW84aBebfRUrJqJIi8dBu2fU72Jxmu6xnVSdY4rgLT5VIpeMIFZtKvQk8I9jgRoDZO6jl7eTY7w3BCnJtMIGUBby4F3g3BQTq1F6culU/BCpGsLmvUZFQ/Wgy7JSXJlm5RANNsNUhWPoOhnYPt3LGx2GYj0usgLxIEsmOI8gpEitNsHZJFqpNsLHgUwD7qCTOvTGmli50mjLRK4IVp22Z7nGwzLQtLtwwYGXS3hCsKDO3vwv4234g2a3J1XZ2aAIVJViVeNic+XvgC7xH+qiYNmR7aU2w1SNYap1fUjpGchEK+exJxRCjHxGLiigyjhnlC85Xk2BzpwQiRWKD/Q9NSPSJZ6UmqFApElJomFcEKwdGL6nKEazYtYoCAWLnKjyFX9jLIG7ZxL/1favCVJVuUlGCvWF+I9JJkTlKvkrKIVP5I4gmTnd1sLLKNMFWj2BbQt8Hw1WyUwXGNyOSmCUjT07hyfAbROJfktFdVIZOsHFwfgIYm2zbZzmP+2oSLNUTGLgT0fj8Q+OlRgbY7ebtgBxyBFvoKfz6AWDHgVzyfr+hydVusSj8vaIEK+xR38UKz3BnLzgFPLJNNMGWIFjyDlA+F3G+R3IsJJ5HJC6yQNk/5HywPIJoYpW94hISVIJl7ApY1slg7ALbPstlrasmwRLjjA1guRWNf/fQeMm1eh2mTBxSBKs9hW1/V24LVJxghcE0z8DeQ3RSlkwVLE2wxZEjvjzBeCsiiShpGlSwtzDJ1jM8tw5poWMyMaflBkcn2HMBqwOcbZbArPfOr7BBNQmWHD1QpPxbS/A1qV28GDPnz6I5cbwEXiU+Gj1KNKFgoLtHxHlnpgwHnt8DvNMFNBg6DEdhYkhNUtY83P7YBlIbqnBMJc9sQSdeexarvOSjcT8VFlfkl82vRyApnMkmyetTrqbzAwBXEPq5CtG2lfLyAHLXCsLTd7h0OxlP32WfGY7AsDdJelVTJOYNpxIsx9dwTOCneFk4m9g+B5AMjMM1d6T6SVaVYEP3Aphha31eoNjc0WqnpiD7gVXMqCGzgxXOTJ3dwDN7gA7tzCS9QJ0IiqQXXR4QrLDRyVFx7kt1KzqHNRV9oTjBoFhbOsFmwNlXwVA+vracnZw9Z1untlh7bwlWEBSFyM9HtG0deXpioT9Ily3LKpcogr1qxkdhmU9J28L562hOOEtlSiTYQ8elsl64jH0ekbatNUawlMiB4uRIzejlJGXioCfYfNpD7Sks/dt3TdBLghVGk+/A+oyU4XkwI4jFm192DQN3CNa5OapH4V4RbCy4GGCtpIHKZM0qprAl+Cupe8ietv3u8YruVIjl8JykSFTdweaP1GXLPZbKZFStHSz1/lT8novdn7eGLwfnN0qvNScpEwctwRY6MwlP4ef2sWw1Hu0pLL2uHAt6TbBZkiXFyBUbovB6m13Rykn0HazjqQA1TWS+Ry8ItjU8HZzfRxzk25gamKRUEJ1O5qXvIw+RXfA74Gy5/BgcpEh0TLDSVyrFU0VWi2BXBmfAYOKIWO4p5QFO1eMkZeKgJNhCZ6adIqdwu87MJLck3ZWqBsFmCwGw5wmVNoqPuZK1f6tBsBwr0Bz/NnmCK0mw2fvQjkvIO1cxiHwCd/KAAFBfsIB9vCpxVwxAPUWiU4LNnfbIFoX/MKLx53rBXC2CpV4DlYphXtU0FZa1nbB0HkQ0rlY4ZdARrE57SFg3FRatBsGKIeV+QE+THE6KQCF1NKgC4VAkWJHaEuYwMAyDZR0Lxj4KjrNod64FYJe6H5SZD+pRI3AAyY4jy2Zcot7rWvhnLIkLr2P1h3gH28vrWjoemPV3JKsawdKO9ktWwyGXu3OQMnFQEWzeUzhtAS/otIfqv1yXWlaLYLMkm3U6eUIyc025Af8C0fi/uoRITs1QJFjqi6Y84PYJ6e0mjJpms9x9b26XL7ILjbHrtufvzlIkurGDXRn6GAz8yd7eIglZqkWw1I+YcilRqbWBVVMmUtc957PRnLjbfl6cS9DDdISncEcKeG6f9hR2jr9zDdUkWGF97iXye7VMT72Gb38HR0FraBKsKLDwSwpMJWUZOxeRttsd6WoJ3gfGpsvrKKjI0rcRPUzM/shZxjAnO1ihPxYSznzvs+mKwzQm4lub3z4kVw2CFdcJqeRbYBgpAw2A8pWQYqGfA7hYUpfI/DcXi9voVcEGBcEWFkjXaQ+l10zFBatNsId3i48ACDgcr3skOxQJln4sW2q63CEnasKCcinzqPVJ3Yq7dkyw0iUfe98XV4NgqWFQsKnlS3Z041cjmriG/A4Z0ARbpEB6FgCRQELnFCavBdcb1ALBikG1NB0PZj1EOMIrDoVrL8bgieDsSdfxLqewFpyc6LVS+4+IsylobnvVMXbkrFFl0mrSX9bOUiTmB++YYGeeAhiPSmDZJ58vsTQaFMmp0LDW8EJwfpuErTkRuzCoWNNswKLsSNU+sAcsweq0h9JrrWqCtUKwAoCc49PDAI5yhIcqUfV6WQxZgv0xOP5DHX+JhA+yyulJ40tXmKEeNzpNkegWwQo9sdAbtr8Jjv04JjD2UEhUNXaw0k5ZPeDYhdZQj/VLxdTarbcBSbB5T2GLA9vbdYF0u0mu1t9riWCzJDt9IiyfOC4+1iEkzkIshuIRcfZlTk7mf3ianFY16Tvh9OLoe5AMTCqeOjD0AIBPS68p13bh5MLj/XM3x0L/BeBr9rYXpL+sBsESywwaYJda0bb/LDkulTtd05jU6y7aHjTxAdMGICQj2rPzrrKTkyBXURD9YDfw4j5dIF165qogWGsEKyDIvljrHyQUbC4OnJE5AYu3iFAg+lMdgr0ZzfHLyMa6GQcrikKn+etEG4SzytWIJL5HbGcvTk9K0j8mNBvykRRjkk3x6NwD2s0dbGvTGeDW/fZg4XDlomoQrHzcbm4oMmFc1OIM5bySSwE44AhWF0iX+C3UiEgtEqyAJkca4k72Ew6QegvR+JFK7ekEKz4r/wHAUuoPaATYKnJi/MNYuZfsn34Pm0EyEKhIjuhY8DaALZTGlPEmRBJiR3L4oSct2IJofKZ0n+UEnd7B5nXHwv+QSMzyEqLxD2SbeE2wuZOnnaSQO5lTAip+olhCc/xHpLkbEAQrXiuFBdJ12kPSHFdNuFYJ9tCLJfRbAGcq46Pq9EQn2BQ4+wA6G0WspcKzux7HT+hUSivo5g5WWE5NtJ4brbMj+VKItZLTGxfg88MAABiWSURBVPZ3TqKmeSyVXUhhVkEliFLl/WTnJF/9x2uCpRZJB+Q+fmVzMh+emx8iGv86aapqnmBF3JMgV78J6ALppLmtunCtE2zuhb8JHGcrY6VSaUOFYH2B0bjyjk5lO1Ubuk2wKvewqh8ydmNeFZ4Di1NKKfZLOmLEwpdY4DfbdVXwd/c+Ftwi2FjwXwDWv2pO30GJgu2RtpvovxlnXsQKGMulNqR6JgNyegtxq3mC9ZsjIV7UL+7XzkyEX3FNiA4Egs2SLNFZpDe4xROil5sAFYJlfAoiCcUdrIPV4DbBqt3DundvWQjFiuBxMNnfCOj0f8FKOwn19OJGisS8wdR1W2oHm7tH3i0RxrYN0fhZ9KpVzgiWfOohWzlKOpvVoRVCLzBRywRrrpq1J2Pw0b0KpJsm4fegRauKwEAh2NxOVj2EhFrOaigTrMC6JfgMGPswcW32dzAiKugnTs5Ji7cwNTC511E7rXj3AfgCE107iXCLYHNzIlPCL4Vo3E//rTgk2BjZS/ubaG67wXZ5LPvMcASGCd8GShIa2jqsZYLFt0/j+NseoLMT8NXb4lURgXQKGDURqDNrP3mFIDThDpOygG4LMI2e/1ERZOyV1gGm5bsgc9vDv7YXrgGJWOgHAK5QsGQPpgYmSN9xDnWCpe76xISoOJjITCT15Z2/h8zrlks3mJcuHUsrY2tfGTcJtjUYBmeb7c2wTgXY5wF2tb1sXsIBweZ21+LkZrx0f8Wc0Uo1JnuSl0mZWawPrwhWvFOAycig2xYnE3XgRieLrr52Sz2r/7xtgwoJ1BnGwRd3vbb8NzsefQBvvzM1283YIwWN1e7Tle7CMPMVNjGwjBuGO96KKqP1m3xYu7WK73n7puSaJ4UHoDtP9kWAz4IZKXuFvA4WtpM8/6gvrUPvEPbvaG77mb1NSsn+UxgsR8QCIPrdl2DY2xFNnCuFL0WISvaF4R+twUngTKxtuXeC23fJ1LVa6ohY4JW7CnjHtgKVqCtscQsMV8nD7IBgqQkhhFGUxPyx0B0AzqnYWLwiWNpJSna42UX75MOP/yzd3e1uNRN5NNFt8if+9tILZy5atGgvoVl1RYUjSYO5GpyP9dqQRpjo5Bmxi56PaNudrvdPDa0AdiIafw/JDrUjzMNhDHadDfUdrNo9rJxnqB32ff/eEvoqGH4o26xXAgP5GNKces7kji5ljXGTYEWfcr8tUaHqTVLyBCepEumOaKUTghTDlZohCqClTPSMYKnpK7Hn0Ffh7bff/p1x48YtT6VSSKfTMAxx9Fn5x7KsbF+NjY0I+P0Xf2ratDWV79VZD6OunfHf+0bUn4tUxpkildaMiRygb8FC2HGty1L9t4RWg+FSefOKlNuya0yPbezRaJ2K6L2P2alXKFc3uHawAiCVjxg3HYTyk0QlSeBwqEZL+N/A+E9t5zsvIJP8QFqZgnNeuR1slmDD5wBc7OjKPeISSnizE+4tHexgyaFUoB3Dx0K0Kk/UlImeESx1J463ex27bNq0aWE6nb5t2LBhyGS8Jw/TNNHe3r504cKF7meUofyoSsmuDI2BwTczGKdxjysdMDAMN+vQnux4Cg2+GRX1dvWCYLMEEPo+7RgsOzFycXJDfQebfZnLpugrWPBup0sUqq9rGo+MJe745LwnC5PIUyvy+NhkXNkmcv+687i9gxXpA9PJd0W5FHcMzGtxQLByu+rD5lKP4ek5qTOgpEwcKAQrEFy9evW0E088ceO+ffvGubsA5LX5/f5bpk+ffpF8Cw8krz3teNSP2jKirn5yu5X23hkr51xFOzpRhcUrghXOFduT7xLqT4oRyYXsaIJVvIeFe1mQCtcfLbvU4TmmvTzl1gbld+E2wWY/fMhHjRIWOyLYp0hpTakfYdmNCcQHlrwXLSVlIm2NiBNAtVzE5LvkPjvY/CzG4/EpVsbaCIaTJGa2IiLd3d2P7t27N1gT97KtwfAIo35zO+8GRPEDr56eakZHsnq82fFODEvvb/aka68INveyuR5gVxLHZe/GrwkWyDkIibs8ykOPQ5TRTiMVDt41Bs2/3QcaMccRjYdlzJGWqQjBOijIUNJwRYKlF2QQrjt03w/aPNI82gcawebn8J577lnPGJsvvRhdEhT3sj6fD8lk8rXt27d/NhKJ/N0l1XQ1y6Z9BcNG/gji7tNLchWWiuxaXd1AuuOruOahH9ONV2zhJcHSA9HFoOwz9WiCzU0+OURCZGPOfAJLtvxRcfUUbWbEQtdawFKCztxHVCwkQiLkjpbt7j8JnR8SrQTB5mJDhUOn3Lik7FYkWPrxLaBShINKgrKJLLJr3KNqOm7tYAvnc8OGDTc1NDRcJu5k8w5JUvPtkpBhGOnOzs7Z55xzTsIllfJqYsHrR5j1Vx7IdMPrO9eskX4zic7ueViS2CJvtAuSXhKsUgwea0GkbUnZkWqCzcFDnkvRiLtTrLxwgshhQ+wsJA/8AYFh7fIr2sVatvlOK0GwOVK4F8AM+bHZSSoSLNWJDFBL5EE+qSI4Tg5kghXTevfdd18C4GavPIuLLaVXXnnl8ksuuWS13TJz7e/iSIsZs8E9PBLuMb7eMJCyrB3gRhjNm59xbUyyisgvZcKPoZgNseDDADtN1jzIOFlogs3BSSa2bCv3j1pXzfgoLPMp6TlmuBgZPAUDf5JuUxEPaGKKT9lddGvoInD8QnpstoKKBEtP/PIEovGP2ZrTV4BO5PKhQAOdYAVWd955Z3D06NHx7u5udHV1eRbGk58nEcbT1dX1vVAoRDlmIq+DwEUnHZV83/gERjSeUJUwnKzF/BHwVCh7B1WNx3OCJR7xMHYrIm3nlYVGE2wPwSrcw3LsR2dggqvl60SShcbkbmmHtlyyhVcJ8bNqOyu731eldrA5xx+Rm9ilY2JFgm0J3gfGptvBcPjvislI6KFaokt7XwshNRgIVoxj7dq1HwkEAonhw4e/V8TKVuPhnN8xa9asBRXpOzbzlEB9QzzZnR6LDJfNHePcFLFJNhkafT50ptL25OG8x/IayMc5xLi4fl+3xB85w28QiX9JE2zbNqmloHIPq1LByM6YWOgP0vWBRagOwx5CLVlabKadrfm/V4pgc8TgrJRjrzEoEmwsJEKajpKFwwCWW9H4d2XlD8nlEp+ImseEDwpJZyoqwVLSPBYOlBrOhBJexOXAu+WWW0b/07HHbXtn77snk0F2qwHHk50HO4MLFixwr/LJ1Z/9IhoD67LOTF4fC4s+Rdxx6sB3seyh5W7BpKyHHnjuLAMQ5cUrBiXjAKF3sIenn3wiITDmSxFJuBuPHgv9HMDFUutS7KJzcz1SSh7oV+ZOsl15sUoSLDHDVXlDFQhWKdmLg3tuWk5pSJM5lWBhzEF08yby+qiEk1MpI6rlYVxgz+upVGruvHnznHs7xsJLJjBzRZJzdMD7BBuoM4C39i7Cqod+SZ70SjRQuR/ixkeU7ovly3gdHinHCjTHv613sLI7WKnsQX3hzJVNc/NpCV8Jxq93U+UhXW6nSMwrriTBrpo+EZZPVJpx4VEgWOniAwXmOfEwJx9HS8b9U4lPda1QQ42AV+USaJeY/ng8vtyyrO+4sDqUVHR3d/MXX3zxC5FI5HYlBaKR+Kpm7GLPd63Zr/Ns6M9+GFYQkXsfUR6D2w1VXPdlSK+YnUp9SST91zvYw2irvciT8AXGu1b2TVjTGp4Ozu9ze7lm9bmdItELgs2+f4gOfiXBUyDYWHAxwFoJ85EC75qo7BtCzSwmmzKRqhcKV1r0usYC1iccEazQsHHjxgsbGxtvESE8XucwFrGy9fX1Ir1idM6cOZSFAuRSlm0GY2dWj1ytZwFjJprbXiUs8sqL5rB5m5QLVRzpHRMYK11OLj8K+r0GIJPlRRNs73Wicg8LdhaikrtkmVWpVoBARjPgdopErwi2NXw5OL9RbpDlpBQIVq4+7eFOOX8WzYnjVW01YuFLLPCbCe3lUiaqnIxYfCYp/FEprIpvckywAiyRXnHy5MmbGhoaxlYjh7GwIZ1Or547d+7lUpMn7h64lQDHB6XkXRQ6lFM4k96CZOBsVz01XbRTyQFDJnym0MbWmaeBGw8TzZb7ilYhWF9gtKs7NtmB5cqYCQeQSbJNQCU/hXtY6TsweaPFidHLAN5HaSIh636KRK8I1rWPDgWCjYX+DEDel4bhbkTisyXmo7iI0gmGxEeeioey2BCYxolYvFmsx/IPfaffo49f7QrBCm2tra3vP/3U09bvbd93spc72TwyolCAlbK2JVNJ4fxUuo7p0jOmGaY/YY3wD88WTPf6ySH+E0TiX/G6a1J/yg4YkkkKxIslxZ8lOLHkF+0jiCZOtx2LCsEaxgdxoOENjKJ4OtpaAuxDpuyHlBcEK1fFpe9gHkQ0fobECOVFyA4pUqrdj9v1imBFP1Qnv6KQEAk2d0q1y7Y2bWFfsjG+paZMwamqV+nCUnpl6+z2b78HjJ2LSNvWoqqz/iEdrQqpXHPqmHW6awSbZY2f/CRQV1d3z5QpU87s7BTVlqryPG8YxoxQKCR2BL2f5Z9adOSwI9e8yVNA2vI8DAd+E+hMu58lpxIw53KUiuLQBLf6Q4bciKmBb5U8Ls7uXM0NAJ9IN51dhWjbStt2dIIVwVJ7ASYqObhdq3E9ovGvl7TZC4LN3cMKr3vKbz6FZMc4XHP/AVu8ZQVaQ6vA8S1ZcSk5ETNrl9lLSlERoUo6OeW7U94hFdpLJFiVFKUi+Uckrl5ONOfQ+DrppEYmYiD7kRK8jRDS1Xei42DYgEzm/8MwD8DiU2DgkwC7UP20he1CtO0Iyo9Neolu3bp1TVdX1yLpBu4L7vcxX3hGeMZDWdW5IPdlojSaOKL1PO2h8BLuTMN8Yd/czNpHN7o/3ApppIRV9DdhB8B+CqM7DubbCYP70WX9PxjsHOlQjWLDkr1roxNshUAUavkmRBNzqkqw2ZcQ8UhQtKHeVdmhSK0Naqcv+3cHoSN2+r0gWIWdXX+ziQQbUyg44EZsdCz0AIBP28F++O+SWeJUjonljaBL9uz2K0KwwpqNGzdG/H5/rFp3suB4smlWU+5+4drTjp/QMP6vb/OM5+TaQ+iVLZBOn365FmrVWIrpFjsgUapKvlxVcQvlS6nVEsHa3U17sYPNEewPAFwhN/k9Uk6PBft2prJzsjNYJfm8nc78370gWNWPn15jIBJsa3glOKdU58rASB+FxVvFsbL60xr6MTj+g6BAPmUiPYyGYAZR1DQm4FubexdcJ6qwFRcF3Bljt1UjhzHLsG3h2eFcHB81D6rtyOQERpg+tGfSj4PxsytaIF3OHDUp+g9RrR+ZVoyfhEjiLzKi0ATbH6ZV4Tmw+AYp/A4LuZshKVdJRsR+Boh2FBcXzir1gUkVc07zimDpyV364EEkWPpduDuOZCoev7Ix9rWyi2W4DpH4YjFBFdvB5mf/rrvu+nhjY+NmAEd46fzUi2BFsXT/6L+68oOWVSKQ7epaj6W/XSjbpGblKuP5SRsu1YNRE2x/fK9rGo+MJXYglN99BhYmYEl8D23CykirHFWXVufuB0DffrwiWLU4ywJriQTbGvo7OI4hzKn86VE5pSrJLXKOSHK5DqhJJwgAyImyXZjaeFTe/4TyQ5PTX0Rq/fr1k7q7u+8dO3bsiV7lMK4WwYoj4fHMxG6kWxFJRJVBq6WGjn/8jgfDYRoTxZGLtCZNsMWhUiE3zmejOXG3NPZ2glTSKq+vMikS831SbXVypO7oiJNAsLmrn52kDy2Om9Ecv8xuam3/rvAuIYWLKV232FotL9An05UnBJu3buvWrRu6urpKO3vID8NWsioEKzIzgQMd+70tkG6LhgsCLcGzwRg9f6cLXfe40st9wR56MQZPBGdPutG9Yx21cgcrBqJyDwvciGj8G45xyCuIhZcAfIUr+hi7ApG2m1zRVUyJhwSrUJS+wGICwcbCZwJcFBqQfzi+hub4j+QblJDMEaDwZh8jr8vGSbCvoljoQwCeldfvkiTvn2HOU4IVwxAF3H0+n/MvIRtMPCfYXJGAg2Ds7JJxVS7NY9XUVMQD1HY0ai93vYMtDqzSPSx/GtHECbYzJSvg6scan45o4n9kuybLeUiwznxFCASrlD1KIuGDLLj0uN+XEI1/QFZ9Vk4tiQ2pi97CxcMHPSdYYZQXBdw9JVhDVMOxXsezb5yJtU+94GCWar9p7uW43gWPYJmxqh//aYItjq/aPSxgpI9w7EGat0jhmLDkYpEN25JZbcVkvCRY0X8s9CKAY+nmUgiW7MkLcDbFtZSu1BSNgJoHs8hzzo376MlsiOiXOUWpCsEK80UB98bGxk2WZfmIw5ES94xgczvXB8G7ZiknwZYaUQ0JZV+QWAOw0ypnFeGFUfTFqI+IS86Nyj0sxdFEZlHEQm+SEg4U08mwHZH4+2W6U5bxmmCVvfYJvxd6gYGdiMbfo4xh34ZKVwSKO+hcjPFt0nWIaYPcA8YvQCTRVqpZ1QhWGCQKuI8ZM+Ze0zQnux0v6wXBZsNwulNr0Zz4Mm1eBol07qhpGe0+xXbsT4AZVyKyWQSkqz+1tINl7FZE2s4rOZjcvZQofD1efsAOjkZV7mFlM+rIDsCdYuOVS5GYHwc1Q1BBiIYsFL3kFOOEpR2Bckl3dhN3de6mzFRJ2+n0rj0WXAawpYqZ6fpPJcNvYBjfsHO8rCrBCqtFAffRo0cn6urqTlVakCUaVZRgGcMIow7tHe/URoF0N4Gj6sqmVGz4Ghj/V6Lbf5+e+COA8SNE29ZRTSgqv3LGx2GYj7uiy7mS8kSQywubJHXDeFO5L+eyutTuQA9gamA0uVpSKUPoCQeKaOI3IJr4Jgk3qjC1hqkbHyKx0G7ax5YYlCQWSuUhububCLW8BM4/psRuNmN9AwznO9gU3Alm3ShbXrTqBJtf72vWrFl31FFHfdGtMJ6KEqxIfdjNz3eNDKg/+lqVz3onWkEgm8fzw2UWscj7K5IN/AWMP4KMdR+WbPmjq8MSxG82fC6rM2NVoapDz2gMowEZ/hKWxEXlkuKPyNG6o/NMcIwEt9JlcWCmuJOog8nut/t6Lqknu2M+GITBmRQ2ppHLzXygMe5a9aeW8NEwcCos66DSvAtc6/AwrmwTO//KPWJHabJjpewUNnHhEBZ/zpFBgoB43Yek+hQdiX67rSdxVcLe/0MU2ejG6WBIwWLid1j+YdwPxh6Xqjpjpyv/d7Het3eEwQwfwLptmwkbwN5yfKqV7yib7GT42eDWdDD2KQBHl/EpEeFMTwL8AWRwtxTGBQOqGYIVNrlZwL0SBFtvGMiA7c38dWcYv/pT7RRIt12hVRAQi3h4wzGw6iaAWY2wYMIwOoFMB1jdzmzVmmvuKF31qAom6y41AhqBIYiAiAsGfz8ybAQY/ODogml2guFVTGl41cmpTU0RrJhaUcC9rq7uFqfT7DrBCmcmq0YLpDsFS7fXCGgENAIaAdcRqDmCFSPc0rZlWpqn20zTHKnq/OQqwTIGxnicHwjM1bsu19egVqgR0AhoBAYlAjVJsD3HxVMsy9oC4IMqyLtCsGLXmk3OxGu/QLoKSLqNRkAjoBHQCFQMgZolWDFiUcB9zJgxd40dO3YGtYC7GwQ7DCY6uPVNNLfdULEZ0Io1AhoBjYBGYFAiUNMEm0f8rrvuuqWuru5CStk7RwRbZ2AEN9He+c4cLH2oOvl3B+Vy04PSCGgENAJDB4EBQbBiOtatWxcdN25ci2wYjzLB5jIzvQXGZ0rXHh0660WPVCOgEdAIaAQkERgwBCvGIwq4m6Yp0l7ZPmSCFRFhIsTQ4o/DSDe5lnfV1lItoBHQCGgENAKDEYEBRbBiAkQBd8bYFp/PN7bchJAIVqAgdq4HDw6OAumDcaXqMWkENAIagQGGwIAjWIGvKODe2NCY8NX7Tip1ZEwhWJFAIsUzg6dA+gBbhNpcjYBGQCMwGBEYkASbn4j169ff29jYOKPYxMgQrPASHunz4c19uwZfgfTBuFr1mDQCGgGNwABCYEATrMC5VAF3W4LNxrciNYr5mvZFNm0dQHOmTdUIaAQ0AhqBAYDAgCdYgbEo4G4Yxs2FeJckWOHM1GBiaqZux8vJHUEsfcJZYu4BMMnaRI2ARkAjoBHwHoFBQbACNlHA3e/3x/MQliTYOgNsT/J+bmaacM39B7yHXPeoEdAIaAQ0AkMBgUFDsGKyCgu4WylrW3h2+KzsJK4IHgeT/S3rKdxo/AqX3nPhUJhcPUaNgEZAI6ARqB4Cg4pgBYyigPuIESOe9vv9o5qamkZloV16xrT6kSMfTB1sj2Hp/c3Vg1v3rBHQCGgENAJDBYFBR7B5kh07duz5XV1dP12wYEEKsZmngBkfRiS+ZqhMrB6nRkAjoBHQCFQXgf8D7s0gPQStxC4AAAAASUVORK5CYII=',
        'JPEG',
        40,
        10,
        0,
        0,
      );
      doc.setFontSize(20);
      doc.setTextColor(0, 0, 0);
      doc.text('Comprovante de Preenchimento Virtual', 40, 55);
      doc.text('de Autodeclaração de Saúde', 56, 64);
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(nomePDFdeclarante, 10, 93);
      doc.text(cpfPDFdeclarante, 10, 99);

      let position = 110;

      if (
        String(r1) === '1' ||
        String(r2) === '1' ||
        String(r3) === '1' ||
        String(r4) === '1' ||
        String(r5) === '1' ||
        String(r6) === '1' ||
        String(r7) === '1' ||
        String(r8) === '1' ||
        String(r9) === '1' ||
        String(r10) === '1' ||
        String(r11) === '1'
      ) {
        doc.text('Sou portador de:', 10, position);
        position += 5;
        if (String(r1) === '1') {
          doc.text('- Doença Pulmonar Obstrutiva.', 15, position);
          position += 5;
        }
        if (String(r2) === '1') {
          doc.text('- Doença Cardiovasculares.', 15, position);
          position += 5;
        }
        if (String(r3) === '1') {
          doc.text('- Diabetes Insulino Dependente.', 15, position);
          position += 5;
        }
        if (String(r4) === '1') {
          doc.text('- Hipertensão.', 15, position);
          position += 5;
        }
        if (String(r5) === '1') {
          doc.text('- Doença Renal Crônica.', 15, position);
          position += 5;
        }
        if (String(r6) === '1') {
          doc.text('- Doença Oncológica.', 15, position);
          position += 5;
        }
        if (String(r7) === '1') {
          doc.text(
            '- Sistema Imunológico Enfraquecido (Imunodeprimido).',
            15,
            position,
          );
          position += 5;
        }
        if (String(r8) === '1') {
          doc.text('- Obesidade Mórbida.', 15, position);
          position += 5;
        }
        if (String(r9) === '1') {
          doc.text('- Doenças Neoplasias Malígnas.', 15, position);
          position += 5;
        }
        if (String(r10) === '1') {
          doc.text('- Asma Grave.', 15, position);
          position += 5;
        }
        if (String(r11) === '1') {
          doc.text(`- Outras - (${r11Justifique})`, 15, position);
          position += 5;
        }
      } else {
        doc.text(
          'Não sou portador de nenhuma doença citada abaixo:',
          10,
          position,
        );
        position += 5;
        doc.text('- Doença Pulmonar Obstrutiva.', 15, position);
        position += 5;
        doc.text('- Doença Cardiovasculares.', 15, position);
        position += 5;
        doc.text('- Diabetes Insulino Dependente.', 15, position);
        position += 5;
        doc.text('- Hipertensão.', 15, position);
        position += 5;
        doc.text('- Doença Renal Crônica.', 15, position);
        position += 5;
        doc.text('- Doença Oncológica.', 15, position);
        position += 5;
        doc.text('- Sistema Imunológico (Imunodeprimido).', 15, position);
        position += 5;
        doc.text('- Obesidade Mórbida.', 15, position);
        position += 5;
        doc.text('- Doenças Neoplasias Malígnas.', 15, position);
        position += 5;
        doc.text('- Asma Grave.', 15, position);
      }

      if (
        String(r12) === '1' ||
        String(r13) === '1' ||
        String(r14) === '1' ||
        String(r15) === '1' ||
        String(r16) === '1'
      ) {
        position > 110 && (position += 10);
        doc.text('Declaro ainda, que:', 10, position);
        position += 5;
        if (String(r12) === '1') {
          doc.text(
            '- Faço uso de medicamentos imunossupressores (medicamentos, usados para evetir a rejeição)',
            15,
            position,
          );
          position += 5;
        }
        if (String(r12) === '1') {
          doc.text('  do órgão transplantado).', 15, position);
          position += 5;
        }
        if (String(r13) === '1') {
          doc.text('- Estou gestante.', 15, position);
          position += 5;
        }
        if (String(r14) === '1') {
          doc.text(
            '- Sou lactante (puérperas-mães de recém-nascidos com até 45 dias de vida).',
            15,
            position,
          );
          position += 5;
        }
        if (String(r15) === '1') {
          doc.text(
            `- Testei positivo em exame laboratorial para COVID 19 no período de: ${r15DataInicialTradado} à ${r15DataFinalTradado}.`,
            15,
            position,
          );
          position += 5;
        }
        if (String(r16) === '1') {
          doc.text(
            '- Em meu domicílio, tive residente com resultado positivo em exame laboratorial para COVID 19',
            15,
            position,
          );
          position += 5;
        }
        if (String(r16) === '1') {
          doc.text(
            `  no período de: ${r16DataInicialTradado} à ${r16DataFinalTradado}.`,
            15,
            position,
          );
          position += 5;
        }
        doc.text(`Formulário preenchido em: ${today}.`, 115, 240);
      } else {
        position > 110 && (position += 10);
        doc.text('Declaro ainda, que:', 15, position);
        position += 5;
        doc.text(
          '- Não faço uso de medicamentos imunossupressores (medicamentos, usados para evetir a rejeição',
          15,
          position,
        );
        position += 5;

        doc.text('  do órgão transplantado).', 15, position);
        position += 5;

        doc.text(
          '- Não testei positivo em exame laboratorial para COVID 19 até a data do preenchimento desse',
          15,
          position,
        );
        position += 5;

        doc.text('  formulário.', 15, position);
        position += 5;

        doc.text(
          '- Em meu domicílio, não tive residente com resultado positivo em exame laboratorial para ',
          15,
          position,
        );
        position += 5;

        doc.text(
          '  COVID 19 até a data do preenchimento desse formulário.',
          15,
          position,
        );
        position += 5;

        doc.text(`Formulário preenchido em: ${today}.`, 115, 240);
      }
      doc.setFontStyle('normal');
      doc.text(`AUTENTICAÇÃO:`, 15, 280);
      doc.setFontStyle('bold');
      doc.setFillColor(0, 38, 153);
      doc.text(`${crypto}`, 53, 280);
      doc.save(`declaracao-${dataPerson[0].nome.trim()}.pdf`);
    }
  }, [
    dataPerson,
    r1,
    r2,
    r3,
    r4,
    r5,
    r6,
    r7,
    r8,
    r9,
    r10,
    r11,
    r11Justifique,
    r12,
    r13,
    r14,
    r15,
    r15DataInicial,
    r15DataFinal,
    r16,
    r16DataInicial,
    r16DataFinal,
    crypto,
  ]);

  // const handleCPF = useCallback(
  //   (e: any) => {
  //     setCpf(e.target.value);
  //     // console.log(`e.target.value: ${e.target.value}`);
  //     // console.log(`CPF: ${cpf}`);
  //   },
  //   [cpf],
  // );

  const handleAceita = useCallback(
    (e: any) => { // eslint-disable-line
      setAceita(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`Aceita: ${aceita}`);
      e.target.value === '0' && setVerificaAceita('0');
    },
    [aceita], // eslint-disable-line
  );

  const handleVerificaAceita = useCallback(
    (e: any) => { // eslint-disable-line
      // console.log(aceita);
      if (aceita === '1') {
        Swal.fire({
          timer: 1000,
          timerProgressBar: true,
          onBeforeOpen: () => {
            Swal.showLoading();
            const timerInterval = setInterval(() => {// eslint-disable-line
              const content = Swal.getContent();
              if (content) {
                const b = content.querySelector('b');// eslint-disable-line
              }
            }, 100);
          },
        });

        setVerificaAceita('1');
        setAceita('');
      } else if (aceita === '0') {
        setVerificaAceita('');

        const swalWithBootstrapButtons = Swal.mixin({ // eslint-disable-line
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        });

        Swal.fire({
          title: 'Tem certeza que não deseja declarar?',
          text: '......',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sim!',
          cancelButtonText: 'Não, quero voltar!',
        }).then((result) => {
          if (result.value) {
            // /////////////SALVANDO NAO DECLARANTE/////////////////////////
            const nomeAPIsalvar = dataPerson[0].nome;
            const cpfAPIsalvar = dataPerson[0].cpf;
            const dataNascimentoAPIsalvar = dataPerson[0].dataNascimento.substr(
              0,
              10,
            );

            setLoading(true);

            api
              .post(`seducapp/`, {
                nome: nomeAPIsalvar,
                email: '',
                cpf: cpfAPIsalvar,
                Data_Nascimento: dataNascimentoAPIsalvar,
                DOENCA_PULMONAR: 0,
                DOENCA_CARDIOVASCULERES: 0,
                DIABETE_INSULINO_DEPENDENTE: 0,
                HIPERTENSAO: 0,
                DOENCA_RENAL_CRONICA: 0,
                DOENCA_ONCOLOGICA: 0,
                SISTEMA_IMUNOLOGICO_ENFRAQUECIDO: 0,
                OBESIDADE_MORBIDA: 0,
                DOENCA_NEOPLASIAS_MALIGNAS: 0,
                ASMA_GRAVE: 0,
                OUTRAS_ENFERMIDADES: 0,
                JUSTIFICAR_OUTRAS_ENFERMIDADES: '',
                USO_MEDICAMENTOS_IMUNOSSUPRESSORES: 0,
                GESTANTE: 0,
                EH_LACTANTE: 0,
                TESTOU_POSITIVO_COVID19: 0,
                DATA_INICIAL_TESTOU_POSITIVO_COVID19: '',
                DATA_FINAL_TESTOU_POSITIVO_COVID19: '',
                TEVE_RESIDENTE_POSITIVO_COVID19: 0,
                DATA_INICIAL_TEVE_RESIDENTE_POSITIVO_COVID19: '',
                DATA_FINAL_TEVE_RESIDENTE_POSITIVO_COVID19: '',
                DECLAROU: 0,
                Token: crypto,
              })
              .then((response) => {// eslint-disable-line

                setTimeout(function (): void {// eslint-disable-line
                  setLoading(false);
                }, 2000);

                Swal.fire({
                  icon: 'success',
                  title: 'Registrado como não declarante!',
                  showConfirmButton: false,
                  timer: 1500,
                });

                // /////////// BAIXAR PDF? //////////////////
                Swal.fire({
                  title:
                    'Deseja baixar o comprovante de não preenchimento desse formulário?',
                  text: '......',
                  icon: 'info',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Sim!',
                  cancelButtonText: 'Não!',
                }).then((validaPDF) => {
                  if (validaPDF.value) {
                    handleDownloadPDFnaoDeclarante();
                    history.push('/auto-declaracao-de-saude-agradecimento');
                  } else if (validaPDF.dismiss === Swal.DismissReason.cancel) {
                    history.push('/auto-declaracao-de-saude-agradecimento');
                  }
                });
                // /////////// BAIXAR PDF? //////////////////
              })
              .catch(() => {
                setTimeout(function (): void {
                  // eslint-disable-line
                  setLoading(false);
                }, 2000);

                Swal.fire({
                  icon: 'info',
                  title: 'Erro ao salvar registro. por favor tente novamente!',
                  showClass: {
                    popup: 'animate__animated animate__fadeInDown',
                  },
                  hideClass: {
                    popup: 'animate__animated animate__fadeOutUp',
                  },
                });
              });

            Swal.fire({
              timer: 1000,
              timerProgressBar: true,
              onBeforeOpen: () => {
                Swal.showLoading();
                const timerInterval = setInterval(() => {// eslint-disable-line
                  const content = Swal.getContent();
                  if (content) {
                    const b = content.querySelector('b');// eslint-disable-line
                  }
                }, 100);
              },
            });
            // /////////////SALVANDO NAO DECLARANTE/////////////////////////
          }
        });
      }
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`setVerificaAceita`);
      // console.log(verificaAceita);
    },
    [verificaAceita, aceita, crypto],// eslint-disable-line
  );

  const handleR1 = useCallback(
    (e: any) => {// eslint-disable-line
      setR1(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R1: ${r1}`);
    },
    [r1],// eslint-disable-line
  );

  const handleR2 = useCallback(
    (e: any) => {// eslint-disable-line
      setR2(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R2: ${r2}`);
    },
    [r2],// eslint-disable-line
  );

  const handleR3 = useCallback(
    (e: any) => {// eslint-disable-line
      setR3(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R3: ${r3}`);
    },
    [r3],// eslint-disable-line
  );

  const handleR4 = useCallback(
    (e: any) => {// eslint-disable-line
      setR4(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R4: ${r4}`);
    },
    [r4],// eslint-disable-line
  );

  const handleR5 = useCallback(
    (e: any) => {// eslint-disable-line
      setR5(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R5: ${r5}`);
    },
    [r5],// eslint-disable-line
  );

  const handleR6 = useCallback(
    (e: any) => {// eslint-disable-line
      setR6(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R6: ${r6}`);
    },
    [r6],// eslint-disable-line
  );

  const handleR7 = useCallback(
    (e: any) => {// eslint-disable-line
      setR7(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R7: ${r7}`);
    },
    [r7],// eslint-disable-line
  );

  const handleR8 = useCallback(
    (e: any) => {// eslint-disable-line
      setR8(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R8: ${r8}`);
    },
    [r8],// eslint-disable-line
  );

  const handleR9 = useCallback(
    (e: any) => {// eslint-disable-line
      setR9(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R9: ${r9}`);
    },
    [r9],// eslint-disable-line
  );

  const handleR10 = useCallback(
    (e: any) => {// eslint-disable-line
      setR10(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R10: ${r10}`);
    },
    [r10],// eslint-disable-line
  );

  const handleR11 = useCallback(
    (e: any) => {// eslint-disable-line
      setR11(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R11: ${r11}`);
      r11 === '0' && setR11Justifique('');
    },
    [r11],
  );

  const handleR11Justifique = useCallback(
    (e: any) => {// eslint-disable-line
      setR11Justifique(e.target.value);

      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R10Justifique: ${r11Justifique}`);
    },
    [r11Justifique],// eslint-disable-line
  );

  const handleR12 = useCallback(
    (e: any) => {// eslint-disable-line
      setR12(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R12: ${r12}`);
    },
    [r12],// eslint-disable-line
  );

  const handleR13 = useCallback(
    (e: any) => {// eslint-disable-line
      setR13(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R13: ${r13}`);
    },
    [r13],// eslint-disable-line
  );

  const handleR14 = useCallback(
    (e: any) => {// eslint-disable-line
      setR14(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R14: ${r14}`);
    },
    [r14],// eslint-disable-line
  );

  const handleR15 = useCallback(
    (e: any) => {// eslint-disable-line
      setR15(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R15: ${r15}`);
      r15 === '0' && setR15DataInicial('');
      r15 === '0' && setR15DataFinal('');
    },
    [r15],
  );

  const handleR15DataInicial = useCallback(
    (e: any) => {// eslint-disable-line
      setR15DataInicial(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`r15DataInicial: ${r15DataInicial}`);
    },
    [r15DataInicial],// eslint-disable-line
  );

  const handleR15DataFinal = useCallback(
    (e: any) => {// eslint-disable-line
      setR15DataFinal(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`r15DataFinal: ${r15DataFinal}`);
    },
    [r15DataFinal],// eslint-disable-line
  );

  const handleR16 = useCallback(
    (e: any) => {// eslint-disable-line
      setR16(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`R16: ${r16}`);
      r16 === '0' && setR16DataInicial('');
      r16 === '0' && setR16DataFinal('');
    },
    [r16],
  );

  const handleR16DataInicial = useCallback(
    (e: any) => {// eslint-disable-line
      setR16DataInicial(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`r16DataInicial: ${r16DataInicial}`);
    },
    [r16DataInicial],// eslint-disable-line
  );

  const handleR16DataFinal = useCallback(
    (e: any) => {// eslint-disable-line
      setR16DataFinal(e.target.value);
      // console.log(`e.target.value: ${e.target.value}`);
      // console.log(`r16DataFinal: ${r16DataFinal}`);
    },
    [r16DataFinal],// eslint-disable-line
  );

  useEffect(() => {
    if (userAcesso[0].SetorID === 15) {
      history.push('/auto-declaracao-analise');
      return;
    }

    setCpf(user.cpf);
    if (cpf === '') {
      Swal.fire({
        icon: 'info',
        title: 'Informe seu CPF!',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
      return;
    }
    // console.log(
    //   `CPF tratado: ${cpf.replace('.', '').replace('.', '').replace('-', '')}`,
    // );

    const cpfValido = isCpf(cpf);

    // console.log(cpfValido);

    if (cpfValido === false) {
      Swal.fire({
        icon: 'info',
        title: `O CPF: ${maskCpf(cpf)} inválido! Tente novamente!`,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
      return;
    }

    setDataPerson([]);
    // console.log('API CPF');
    // console.log(cpf);
    const cpfTratado = cpf.replace('.', '').replace('.', '').replace('-', '');
    // console.log(cpfTratado);

    // /////////////VALIDANDO CPF/////////////////////////
    setLoading(true);
    api
      .post(`seducapp/validar`, {
        cpf: cpfTratado,
      })
      .then((response) => {
        setTimeout(function (): void {
          // eslint-disable-line
          setLoading(false);
        }, 2000);

        if (response.data.validation) {
          Swal.fire({
            icon: 'info',
            title: `O CPF: ${maskCpf(cpf)} já preencheu esse formulário!`,
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          // console.log(response.data);
          return;
        }
        const cryptoValue = MD5(response.data[0].nome + response.data[0].cpf);
        setCrypto(cryptoValue);
        setDataPerson(response.data);
        setAceita('0');
        setR1(3);
        setR2(3);
        setR3(3);
        setR4(3);
        setR5(3);
        setR6(3);
        setR7(3);
        setR8(3);
        setR9(3);
        setR10(3);
        setR11('3');
        setR11Justifique('3');
        setR12(3);
        setR13(3);
        setR14(3);
        setR15('3');
        setR15DataInicial('3');
        setR15DataFinal('3');
        setR16('3');
        setR16DataInicial('3');
        setR16DataFinal('3');
        setAceita('');
        setVerificaAceita('');
      })
      .catch(() => {
        setTimeout(function (): void {
          // eslint-disable-line
          setLoading(false);
        }, 2000);

        Swal.fire({
          icon: 'info',
          title: `Seu CPF: ${maskCpf(
            cpf,
          )} não está hábito para o preenchimento desse formulário!`,
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
      });

    Swal.fire({
      timer: 1000,
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
        const timerInterval = setInterval(() => {// eslint-disable-line
          const content = Swal.getContent();
          if (content) {
            const b = content.querySelector('b');// eslint-disable-line
          }
        }, 100);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cpf, userAcesso]);

  const handleSubmitAceite = useCallback(async (data: SignInFormData) => {},// eslint-disable-line
    [],
  );

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {// eslint-disable-line
      const d = new Date();
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      const today = `${ye}-${mo}-${da}`;

      const e = new Date(1575158400000); // '2019-12-01'
      const ye2 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(e);
      const mo2 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(e);
      const da2 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(e);
      const InicioDaPandemia = `${ye2}-${mo2}-${da2}`;

      if (
        r1 === 3 ||
        r2 === 3 ||
        r3 === 3 ||
        r4 === 3 ||
        r5 === 3 ||
        r6 === 3 ||
        r7 === 3 ||
        r8 === 3 ||
        r9 === 3 ||
        r10 === 3 ||
        r11 === '3' ||
        r12 === 3 ||
        r13 === 3 ||
        r14 === 3 ||
        r15 === '3' ||
        r16 === '3'
      ) {
        Swal.fire({
          icon: 'info',
          title: 'Todos os itens devem ser respondidos!',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
        return;
      }

      if (
        (r11 === '1' && r11Justifique === '3') ||
        (r11 === '1' && r11Justifique === '')
      ) {
        Swal.fire({
          icon: 'info',
          title:
            'Se você marcou a opção 11 como SIM, precisará informar qual(is) as outra(s) Doença(s)!',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
        return;
      }

      if (
        (r15 === '1' && r15DataInicial === '3') ||
        (r15 === '1' && r15DataInicial === '') ||
        (r15 === '1' && r15DataFinal === '3') ||
        (r15 === '1' && r15DataFinal === '')
      ) {
        Swal.fire({
          icon: 'info',
          title:
            'Se você marcou a opção 15 como SIM, precisará informar o período que ficou doente de COVID 19!',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
        return;
      }
      if (
        (r15 === '1' && r15DataInicial !== '3') ||
        (r15 === '1' && r15DataInicial !== '') ||
        (r15 === '1' && r15DataFinal !== '3') ||
        (r15 === '1' && r15DataFinal !== '')
      ) {
        // console.log(r15DataInicial);
        if (r15DataInicial > today) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 15, a data inicial não pode ser maior que a data de hoje!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        if (r15DataFinal > today) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 15, a data final não pode ser maior que a data de hoje!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        if (r15DataInicial < InicioDaPandemia) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 15, a data inicial não pode ser menor que data do início da pandemia do COVID 19!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        if (r15DataFinal < InicioDaPandemia) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 15, a data final não pode ser menor que data do início da pandemia do COVID 19!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        if (r15DataFinal < r15DataInicial) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 15, a data final não pode ser menor que data inicial!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }
      }
      if (
        (r16 === '1' && r16DataInicial === '3') ||
        (r16 === '1' && r16DataInicial === '') ||
        (r16 === '1' && r16DataFinal === '3') ||
        (r16 === '1' && r16DataFinal === '')
      ) {
        Swal.fire({
          icon: 'info',
          title:
            'Se você marcou a opção 16 como SIM, precisará informar o período que essa pessoa ficou doente de COVID 19!',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
        return;
      }
      if (
        (r16 === '1' && r16DataInicial !== '3') ||
        (r16 === '1' && r16DataInicial !== '') ||
        (r16 === '1' && r16DataFinal !== '3') ||
        (r16 === '1' && r16DataFinal !== '')
      ) {
        if (r16DataInicial > today) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 16, a data inicial não pode ser maior que a data de hoje!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        if (r16DataFinal > today) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 16, a data final não pode ser maior que a data de hoje!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        // /////
        if (r16DataInicial < InicioDaPandemia) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 16, a data inicial não pode ser menor que data do início da pandemia do COVID 19!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        if (r16DataFinal < InicioDaPandemia) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 16, a data final não pode ser menor que data do início da pandemia do COVID 19!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }

        if (r16DataFinal < r16DataInicial) {
          Swal.fire({
            icon: 'info',
            title:
              'Na opção 16, a data final não pode ser menor que data inicial!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
          return;
        }
      }

      // /////////////SALVANDO DECLARANTE/////////////////////////
      // console.log(dataPerson[0].nome);
      // console.log(dataPerson[0].cpf);
      // console.log(dataPerson[0].dataNascimento);

      const nomeAPIsalvar = dataPerson[0].nome;
      const cpfAPIsalvar = dataPerson[0].cpf;
      const dataNascimentoAPIsalvar = dataPerson[0].dataNascimento.substr(
        0,
        10,
      );
      const cryptoValue = MD5(nomeAPIsalvar + cpfAPIsalvar);
      setCrypto(cryptoValue);

      // console.log(nomeAPIsalvar);
      // console.log(cpfAPIsalvar);
      // console.log(dataNascimentoAPIsalvar);

      setLoading(true);
      api
        .post(`seducapp/`, {
          nome: nomeAPIsalvar,
          email: '',
          cpf: cpfAPIsalvar,
          Data_Nascimento: dataNascimentoAPIsalvar,
          DOENCA_PULMONAR: r1,
          DOENCA_CARDIOVASCULERES: r2,
          DIABETE_INSULINO_DEPENDENTE: r3,
          HIPERTENSAO: r4,
          DOENCA_RENAL_CRONICA: r5,
          DOENCA_ONCOLOGICA: r6,
          SISTEMA_IMUNOLOGICO_ENFRAQUECIDO: r7,
          OBESIDADE_MORBIDA: r8,
          DOENCA_NEOPLASIAS_MALIGNAS: r9,
          ASMA_GRAVE: r10,
          OUTRAS_ENFERMIDADES: parseInt(r11),// eslint-disable-line
          JUSTIFICAR_OUTRAS_ENFERMIDADES: r11Justifique,
          USO_MEDICAMENTOS_IMUNOSSUPRESSORES: r12,
          GESTANTE: r13,
          EH_LACTANTE: r14,
          TESTOU_POSITIVO_COVID19: parseInt(r15),// eslint-disable-line
          DATA_INICIAL_TESTOU_POSITIVO_COVID19: r15DataInicial,
          DATA_FINAL_TESTOU_POSITIVO_COVID19: r15DataFinal,
          TEVE_RESIDENTE_POSITIVO_COVID19: parseInt(r16),// eslint-disable-line
          DATA_INICIAL_TEVE_RESIDENTE_POSITIVO_COVID19: r16DataInicial,
          DATA_FINAL_TEVE_RESIDENTE_POSITIVO_COVID19: r16DataFinal,
          DECLAROU: 1,
          Token: crypto,
        })
        .then((response) => {// eslint-disable-line

          setTimeout(function (): void {// eslint-disable-line
            setLoading(false);
          }, 2000);

          // /////////// BAIXAR PDF? //////////////////
          Swal.fire({
            title:
              'Deseja baixar o comprovante de preenchimento desse formulário?',
            text: '......',
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim!',
            cancelButtonText: 'Não!',
          }).then((validaPDF) => {
            if (validaPDF.value) {
              handleDownloadPDFDeclarante();
              history.push('/auto-declaracao-de-saude-agradecimento');
            } else if (validaPDF.dismiss === Swal.DismissReason.cancel) {
              history.push('/auto-declaracao-de-saude-agradecimento');
            }
          });
          // /////////// BAIXAR PDF? //////////////////
        })
        .catch(() => {
          setTimeout(function (): void {
            // eslint-disable-line
            setLoading(false);
          }, 2000);

          Swal.fire({
            icon: 'info',
            title: 'Erro ao salvar registro. por favor tente novamente!',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
        });

      Swal.fire({
        timer: 1000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          const timerInterval = setInterval(() => {// eslint-disable-line
            const content = Swal.getContent();
            if (content) {
              const b = content.querySelector('b');// eslint-disable-line
            }
          }, 100);
        },
      });
      // /////////////SALVANDO DECLARANTE/////////////////////////
    },
    [// eslint-disable-line
      history,
      r1,
      r2,
      r3,
      r4,
      r5,
      r6,
      r7,
      r8,
      r9,
      r10,
      r11,
      r11Justifique,
      r12,
      r13,
      r14,
      r15,
      r15DataInicial,
      r15DataFinal,
      r16,
      r16DataInicial,
      r16DataFinal,
      crypto,
    ],
  );

  return (
    <Container>
      <ModalConexao />
      <DrawerApp />
      {/* <Header>
        <HeaderContent>
          <ButtonSignOut type="button" onClick={signOut}>
            <FiPower color="#ffffff" style={{ height: 30, width: 30 }} />
          </ButtonSignOut>
          <img src={logo} alt="" />
          <HeaderTitle>
            Formulário Virtual para Preenchimento de Autodeclaração de Saúde
          </HeaderTitle>
        </HeaderContent>
      </Header> */}

      {dataPerson.length !== 0 && (
        <Form ref={formRefAceite} onSubmit={handleSubmitAceite}>
          <Content>
            <ContentSubHeader style={{ padding: 10, height: 120 }}>
              {!!dataPerson && (
                <ContentTitle>
                  Eu, {dataPerson[0].nome}, inscrito(a) no Cadastro de Pessoa
                  Física (CPF): {maskCpf(dataPerson[0].cpf)}. Manifesto para
                  fins específicos que:
                </ContentTitle>
              )}
            </ContentSubHeader>
            <div style={{ flex: 1 }}>
              <ContentSubBody style={{ alignItems: 'center', height: 50 }}>
                <RadioButton
                  type="radio"
                  name="fazerForm"
                  label=""
                  value={1}
                  onChange={(e) => handleAceita(e)}
                />
                <ContentText style={{ marginTop: 10 }}>
                  Desejo declarar informações sobre minha condição de saúde.
                </ContentText>
              </ContentSubBody>

              <Line />

              <ContentSubBody style={{ alignItems: 'center', height: 50 }}>
                <RadioButton
                  type="radio"
                  name="fazerForm"
                  label=""
                  value={0}
                  onChange={(e) => handleAceita(e)}
                />
                <ContentText style={{ marginTop: 10 }}>
                  Não desejo declarar informações sobre minha condição de saúde.
                </ContentText>
              </ContentSubBody>

              <Line />
            </div>
          </Content>
        </Form>
      )}

      {(aceita === '0' || aceita === '1') && (
        <ContentButton>
          <ContentButton
            style={{
              margin: 0,
              marginLeft: 10,
              marginRight: 5,
            }}
          >
            <Button
              type="button"
              onClick={handleVerificaAceita}
              style={{
                height: 40,
                margin: 0,
                marginTop: 10,
                fontFamily: 'Arial',
                fontSize: 19,
              }}
            >
              Prosseguir
            </Button>
          </ContentButton>
        </ContentButton>
      )}

      {verificaAceita === '1' && (
        <Form ref={formRefItens} onSubmit={handleSubmit}>
          <Content>
            <ContentSubHeader>
              <ContentTitle>Sou portador de:</ContentTitle>
            </ContentSubHeader>

            <div style={{ flex: 1 }}>
              <ContentSubBody>
                <ContentText>
                  01 - Doença pulmonar obstrutiva crônica: *
                </ContentText>
                <RadioButton
                  type="radio"
                  name="r1"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR1(e)}
                />
                <RadioButton
                  type="radio"
                  name="r1"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR1(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>02 - Doença Cardiovasculares: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r2"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR2(e)}
                />
                <RadioButton
                  type="radio"
                  name="r2"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR2(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>03 - Doença Insulino dependente: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r3"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR3(e)}
                />
                <RadioButton
                  type="radio"
                  name="r3"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR3(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>04 - Hipertensão: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r4"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR4(e)}
                />
                <RadioButton
                  type="radio"
                  name="r4"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR4(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>05 - Doença renal crônica: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r5"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR5(e)}
                />
                <RadioButton
                  type="radio"
                  name="r5"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR5(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>06 - Doença oncológica: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r6"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR6(e)}
                />
                <RadioButton
                  type="radio"
                  name="r6"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR6(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>
                  07 - Sistema imunológico enfraquecido (imunodeprimido): *
                </ContentText>
                <RadioButton
                  type="radio"
                  name="r7"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR7(e)}
                />
                <RadioButton
                  type="radio"
                  name="r7"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR7(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>08 - Obesidade mórbida: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r8"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR8(e)}
                />
                <RadioButton
                  type="radio"
                  name="r8"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR8(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>09 - Doenças Neoplasias Malignas: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r9"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR9(e)}
                />
                <RadioButton
                  type="radio"
                  name="r9"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR9(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>10 - Asma Grave: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r10"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR10(e)}
                />
                <RadioButton
                  type="radio"
                  name="r10"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR10(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody style={{ height: 110 }}>
                <ContentText>
                  11 - Outras enfermidades que justifiquem, segundo avaliação e
                  atestado médico, o isolamento mais restritivo: *
                </ContentText>
                <RadioButton
                  type="radio"
                  name="r11"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR11(e)}
                />
                <RadioButton
                  type="radio"
                  name="r11"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR11(e)}
                />
              </ContentSubBody>

              {r11 === '1' && (
                <>
                  <ContentSubBody style={{ height: 50 }}>
                    <input
                      type="text"
                      name="r11Justifique"
                      onBlur={(e) => handleR11Justifique(e)}
                      placeholder="Informe qual(is) outra(s)  Doença(s) *"
                      style={{
                        fontFamily: 'Arial',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        marginLeft: 28,
                        marginBottom: 10,
                        marginTop: -20,
                        padding: 8,
                        height: 40,
                        width: '93%',
                      }}
                    />
                  </ContentSubBody>
                </>
              )}

              <Line />
            </div>
          </Content>

          <Content>
            <ContentSubHeader>
              <ContentTitle>Declaro ainda, que:</ContentTitle>
            </ContentSubHeader>

            <div style={{ flex: 1 }}>
              <ContentSubBody style={{ height: 125 }}>
                <ContentText>
                  12 - Faço use de medicamentos imunossupressores (medicamentos,
                  usados para evitar a rejeição do órgão transplantado): *
                </ContentText>
                <RadioButton
                  type="radio"
                  name="r12"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR12(e)}
                />
                <RadioButton
                  type="radio"
                  name="r12"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR12(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody>
                <ContentText>13 - Estou gestante: *</ContentText>
                <RadioButton
                  type="radio"
                  name="r13"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR13(e)}
                />
                <RadioButton
                  type="radio"
                  name="r13"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR13(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody style={{ height: 100 }}>
                <ContentText>
                  14 - Sou lactante (puérperas-mães de recém-nascidos com até 45
                  dias de vida): *
                </ContentText>
                <RadioButton
                  type="radio"
                  name="r14"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR14(e)}
                />
                <RadioButton
                  type="radio"
                  name="r14"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR14(e)}
                />
              </ContentSubBody>

              <Line />

              <ContentSubBody style={{ height: 100 }}>
                <ContentText>
                  15 - testei positivo em exame laboratorial para COVID 19: *
                </ContentText>
                <RadioButton
                  type="radio"
                  name="r15"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR15(e)}
                />
                <RadioButton
                  type="radio"
                  name="r15"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR15(e)}
                />
              </ContentSubBody>

              {r15 === '1' && (
                <>
                  <ContentSubBody style={{ height: 50 }}>
                    <ContentSubLabel
                      style={{
                        borderTopLeftRadius: 15,
                        borderBottomLeftRadius: 15,
                        paddingLeft: 15,
                      }}
                    >
                      Período: *
                    </ContentSubLabel>
                    <input
                      type="date"
                      name="r15DataInicial"
                      onBlur={(e) => handleR15DataInicial(e)}
                      // onChange={(e) =>
                      //   (e.target.value = maskDateOfBirth(e.target.value))}
                      placeholder="03/15/2020 *"
                      style={{
                        fontFamily: 'Arial',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        marginBottom: 10,
                        marginTop: -20,
                        padding: 8,
                        height: 40,
                        width: 170,
                      }}
                    />

                    <ContentSubLabel style={{ marginLeft: 0, marginRight: 0 }}>
                      à
                    </ContentSubLabel>

                    <input
                      type="date"
                      name="r15DataFinal"
                      onBlur={(e) => handleR15DataFinal(e)}
                      // onChange={(e) =>
                      //   (e.target.value = maskDateOfBirth(e.target.value))}
                      placeholder="04/22/2020 *"
                      style={{
                        fontFamily: 'Arial',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        marginBottom: 10,
                        marginTop: -20,
                        padding: 8,
                        height: 40,
                        width: 170,
                      }}
                    />
                    <ContentSubLabel
                      style={{
                        marginLeft: 0,
                        borderTopRightRadius: 15,
                        borderBottomRightRadius: 15,
                        paddingLeft: 15,
                      }}
                    />
                  </ContentSubBody>
                </>
              )}

              <Line />

              <ContentSubBody style={{ height: 110 }}>
                <ContentText>
                  16 - Em meu domicílio, tive residente com resultado positivo
                  em exame laboratorial para COVID 19: *
                </ContentText>
                <RadioButton
                  type="radio"
                  name="r16"
                  label="Sim"
                  value={1}
                  onChange={(e) => handleR16(e)}
                />
                <RadioButton
                  type="radio"
                  name="r16"
                  label="Não"
                  value={0}
                  onChange={(e) => handleR16(e)}
                />
              </ContentSubBody>

              {r16 === '1' && (
                <>
                  <ContentSubBody style={{ height: 50 }}>
                    <ContentSubLabel
                      style={{
                        borderTopLeftRadius: 15,
                        borderBottomLeftRadius: 15,
                        paddingLeft: 15,
                      }}
                    >
                      Período: *
                    </ContentSubLabel>
                    <input
                      type="date"
                      name="r16DataInicial"
                      onBlur={(e) => handleR16DataInicial(e)}
                      // onChange={(e) =>
                      //   (e.target.value = maskDateOfBirth(e.target.value))
                      // }
                      placeholder="03/15/2020 *"
                      style={{
                        fontFamily: 'Arial',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        marginBottom: 10,
                        marginTop: -20,
                        padding: 8,
                        height: 40,
                        width: 170,
                      }}
                    />

                    <ContentSubLabel style={{ marginLeft: 0, marginRight: 0 }}>
                      à
                    </ContentSubLabel>

                    <input
                      type="date"
                      name="r16DataFinal"
                      onBlur={(e) => handleR16DataFinal(e)}
                      // onChange={(e) =>
                      //   (e.target.value = maskDateOfBirth(e.target.value))
                      // }
                      placeholder="04/22/2020 *"
                      style={{
                        fontFamily: 'Arial',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        marginBottom: 10,
                        marginTop: -20,
                        padding: 8,
                        height: 40,
                        width: 170,
                      }}
                    />
                    <ContentSubLabel
                      style={{
                        marginLeft: 0,
                        borderTopRightRadius: 15,
                        borderBottomRightRadius: 15,
                        paddingLeft: 15,
                      }}
                    />
                  </ContentSubBody>
                </>
              )}

              <Line />
            </div>
          </Content>

          <ContentButton style={{ height: '100%', width: '100%' }}>
            <Button type="submit" style={{ fontFamily: 'Arial', fontSize: 20 }}>
              Enviar
            </Button>
          </ContentButton>
        </Form>
      )}
      {loading && <Loading />}
    </Container>
  );
};

export default AutoDeclaracaoDeSaude;
